import RicePreviewForm from './src/RicePreviewForm.vue';

RicePreviewForm.install = function ( Vue ) {
    Vue.component(RicePreviewForm.name,RicePreviewForm);
}

export default RicePreviewForm;


//////////////////
// WEBPACK FOOTER
// ./packages/RicePreviewForm/index.js
// module id = null
// module chunks = 